import { Injectable, signal } from '@angular/core'
import { Subject } from 'rxjs'
import { TraceNodeResult } from '../models/canvas.model'

@Injectable()
export class CanvasTraceStateService {
  nodeResults = signal<Record<string, TraceNodeResult>>({})

  showContent$ = new Subject<{ contentId: number; contentType: string }>()

  showContent(contentId: number, contentType: string): void {
    this.showContent$.next({ contentId, contentType })
  }
}
